<div class="col-auto my-2 has-validation">
  <label
    class="form-label"
    [class.required]="hasRequiredValidator()"
    for="{{ inputFormControlName() }}"
  >
    {{ label() | translate }}
  </label>
  <input
    class="form-control"
    type="date"
    id="{{ inputFormControlName() }}"
    [formControl]="inputFormControl()"
    [attr.required]="hasRequiredValidator()"
    [disabled]="disabled()"
  />

  @if (inputFormControl().touched && inputFormControl().invalid) {
    <div class="feedback">
      <div *ngIf="errorKeys().length > 0">
        {{ getErrorMessage(errorKeys()[0]) | translate }}
      </div>
    </div>
  } @else if (leaveSpaceForValidation()) {
    <div class="placeholder-feedback"></div>
  }
</div>
